import { normalize } from 'normalizr';
import ErrorResponse from './ErrorResponse';

class ApiHelper {
  static getCurrentLocale() {
    return 'en';
  }

  static get(url, schema = null, access_token = '') {
    return ApiHelper.submit(url, 'GET', null, schema, access_token);
  }

  static post(url, data, schema = null, access_token = '') {
    return ApiHelper.submit(
      url,
      'POST',
      JSON.stringify(data),
      schema,
      access_token
    );
  }

  static put(url, data, schema = null, access_token = '') {
    return ApiHelper.submit(
      url,
      'PUT',
      JSON.stringify(data),
      schema,
      access_token
    );
  }

  static delete(url, schema = null, access_token = '') {
    return ApiHelper.submit(url, 'DELETE', null, schema, access_token);
  }

  static submit(
    url,
    method,
    data = null,
    schema,
    access_token = '',
    imageName = 'image',
    fileURL = null
  ) {
    return new Promise((resolve, reject) => {
      let headers = new Headers({
        'Accept-Language': ApiHelper.getCurrentLocale(),
        Accept: 'application/json',
        'Content-Type': fileURL ? 'multipart/form-data;' : 'application/json'
      });

      if (access_token !== '') {
        headers.append('Authorization', 'Bearer ' + access_token);
      }

      let config = {
        method,
        headers
      };

      if (fileURL) {
        let data = new FormData();

        fileURL = fileURL.replace('file://', '');
        data.append(imageName, {
          uri: fileURL,
          name: 'image.jpg',
          type: 'image/jpg'
        });

        Object.keys(data).forEach(key => {
          let value = data[key];

          if (value instanceof Array) {
            value.forEach(arrayVal => {
              data.append(key + '[]', arrayVal);
            });
          } else {
            data.append(key, value);
          }
        });
      }

      if (data !== null) {
        config.body = data;
      }

      let request = new Request(process.env.REACT_APP_API_URL + url, config);

      fetch(request)
        .then(response => {
          if (response.ok) {
            if (response.status === 204) {
              resolve();
              return;
            } else {
              return response.json();
            }
          }

          throw response;
        })
        .then(responseJson => {
          if (schema) resolve(normalize(responseJson, schema));
          else resolve(responseJson);
        })
        .catch(error => {
          if (error.status === 422) {
            error.json().then(errorJson => {
              let errorResponse = new ErrorResponse();
              errorResponse.statusCode = error.status;
              errorResponse.message = 'Validation error';
              errorResponse.errors.record(errorJson);

              if (errorJson)
                errorResponse.message = errorJson[
                  Object.keys(errorJson)[0]
                ].toString();

              reject(errorResponse);
            });
          } else if (error.status === 401) {
            let errorResponse = new ErrorResponse();
            errorResponse.statusCode = error.status;
            errorResponse.message = 'Unauthorized';

            reject(errorResponse);
          } else if (error.status === 404) {
            let errorResponse = new ErrorResponse();
            errorResponse.statusCode = error.status;
            errorResponse.message = 'Not Found';

            reject(errorResponse);
          } else if (error.status === 500) {
            let errorResponse = new ErrorResponse();
            errorResponse.statusCode = error.status;
            errorResponse.message = 'Server error';

            reject(errorResponse);
          } else {
            try {
              error
                .json()
                .then(errorJson => {
                  let errorResponse = new ErrorResponse();
                  errorResponse.statusCode = error.status;
                  if (errorJson !== '') {
                    errorResponse.message = errorJson;
                  } else {
                    errorResponse.message =
                      'Unexpected Error. Please try again late';
                  }
                  errorResponse.errors.record(errorJson);

                  reject(errorResponse);
                })
                .catch(e => {
                  let errorResponse = new ErrorResponse();
                  errorResponse.statusCode = error.status;
                  errorResponse.message =
                    'Unexpected Error. Please try again late';

                  reject(errorResponse);
                });
            } catch (e) {
              let errorResponse = new ErrorResponse();
              errorResponse.statusCode = error.status;
              errorResponse.message = 'Unexpected Error. Please try again late';

              reject(errorResponse);
            }
          }
        });
    });
  }
}

export default ApiHelper;



// WEBPACK FOOTER //
// ./src/api/ApiHelper.js